import Page from "webPage/Page";
import Countdown from "util/Countdown";

Page.register(['post-type-archive-webinars', 'page-template-event', 'page-template-event-access-identity'], () => {
    let $countdowns = $('.js-webinar-countdown');

    $countdowns.each(function (i, e) {
        new Countdown($(e));
    });
});
